import React, {Component} from 'react'
import {SliderTemplateStyle} from './../../styles'
import defaultPicture from './../../static/default_picture_RM.jpg'

export default class SliderTemplate extends Component {
  state = {
    active: 0,
    lastPicture: defaultPicture,
    lastPicturePosition: 'center',
  }

  componentDidMount() {
    this.setState({ 
      lastPicture: this.props.items[0].image !== '' ? this.props.items[0].image : this.state.lastPicture,
      lastPicturePosition: this.props.items[0].picture_position !== '' ? this.props.items[0].picture_position : this.state.lastPicturePosition
    })
  }

  updateSlides = (index) => (e) => {
    e.preventDefault()
    this.setState({ 
      active: index,
      lastPicture: this.props.items[index].image !== '' ? this.props.items[index].image : this.state.lastPicture,
      lastPicturePosition: this.props.items[index].picture_position !== '' ? this.props.items[index].picture_position : this.state.lastPicturePosition
    })
  }
  
  render() {
    const { title, items } = this.props
    return (
      <div className={`product-template--slider product-template ${SliderTemplateStyle(this.state.lastPicture)}`}>
        <div className="template-scroll flex">
          <div className={ `template-left template-left--${this.state.lastPicturePosition}` }></div>
          <div className="template-right template-content">
            { title && <h2 className="subtitle">{ title }</h2> }
            <ul className="reset">
              {
                items.map((slide, index) => (
                  <li key={index} className={`flex ${ index === this.state.active ? 'active' : ''}`} onClick={this.updateSlides(index)}> 
                    <span className="number">{index + 1}</span> 
                    <span className="label"> { slide.description } </span>
                  </li>
                ))
              }
            </ul>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/SliderTemplates/SliderTemplate.js